$(function(){
    WPAdminBarPadding();
    $(window).on('resize', WPAdminBarPadding);
});

function WPAdminBarPadding() {
    if($('#wpadminbar').length != 0) {
        var adminbar = $('#wpadminbar').outerHeight(true);
        $('body').css('padding-top', adminbar + 'px');
        $('.big-header').css('top', adminbar + 'px');
    }
}

